import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Hero() {
  const navigate = useNavigate();
  const [query, setQuery] = useState('');

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const term = query.trim();
    navigate(term ? `/?q=${encodeURIComponent(term)}` : '/');
    if (term) {
      window.setTimeout(() => {
        document.getElementById('series')?.scrollIntoView({ behavior: 'smooth' });
      }, 120);
    }
  };

  return (
    <section className="relative flex min-h-[560px] w-full items-center overflow-hidden bg-foreground-950 md:min-h-[640px]">
      {/* background image */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://readdy.ai/api/search-image?query=Stylized%20dark%20anime%20cinematic%20hero%20backdrop%20of%20a%20starlit%20night%20sky%20with%20flowing%20nebula%20ribbons%20and%20silhouetted%20towering%20city%20spires%2C%20warm%20coral%2C%20amber%20and%20charcoal%20palette%2C%20artistic%20dreamy%20atmosphere%2C%20soft%20bokeh%20sparkles%2C%20no%20text%2C%20high%20detail%20editorial%20illustration&width=1600&height=900&seq=hero-dongman-2026&orientation=landscape')",
        }}
      />
      {/* dark overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/45 to-background-800/60" />

      <div className="relative z-10 mx-auto w-full max-w-4xl px-4 py-24 text-center md:px-6 md:py-28">
        <span className="inline-flex items-center gap-2 rounded-full border border-accent-400/40 bg-accent-500/15 px-4 py-1.5 text-xs font-medium text-accent-300">
          <i className="ri-flashlight-fill" /> 分集剧情 · 每话简介 · 剧情梳理 · 故事线解说
        </span>
        <h1 className="mt-6 font-heading text-3xl font-black leading-tight text-background-50 md:text-5xl">
          想看某部番每话讲了什么？<br className="hidden md:block" />
          <span className="text-accent-300">打开就能对照着看</span>
        </h1>
        <p className="mx-auto mt-5 max-w-2xl text-base leading-7 text-background-200 md:text-lg">
          羞羞动漫网按话整理每部番剧的分集剧情简介，配合剧情梳理与解说内容，帮你快速抓住故事线走向。补番、追更、回顾剧情都适用。
        </p>

        {/* search */}
        <form
          onSubmit={handleSearch}
          className="mx-auto mt-8 flex w-full max-w-xl flex-col gap-2 sm:flex-row sm:items-center sm:gap-0"
        >
          <div className="flex flex-1 items-center gap-2 rounded-md bg-background-50/10 px-4 py-3 backdrop-blur sm:rounded-r-none sm:border-r sm:border-background-50/15">
            <i className="ri-search-line text-lg text-background-300" />
            <input
              type="text"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="输入番剧名，如：星澜之旅"
              className="w-full bg-transparent text-sm text-background-50 outline-none placeholder:text-background-400"
            />
          </div>
          <button
            type="submit"
            className="whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-accent-600 sm:rounded-l-none"
          >
            搜索剧情
          </button>
        </form>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <a
            href="#episode"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-clapperboard-fill" /> 看热门分集
          </a>
          <a
            href="#storyline"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-50/30 bg-background-50/10 px-5 py-2.5 text-sm font-semibold text-background-50 backdrop-blur transition-colors hover:bg-background-50/20"
          >
            <i className="ri-list-unordered" /> 剧情梳理方式
          </a>
        </div>
      </div>
    </section>
  );
}